module.exports = __webpack_public_path__ + "static/media/box-arrow-up-right.32ea4ca4.svg";